import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ProfileManager from './component'
import { setServerProfiles } from '../../../../data'

function mapDispatchToProps(dispatch) {
    return bindActionCreators({ setServerProfiles }, dispatch)
}

export default connect(null, mapDispatchToProps)(ProfileManager)



// WEBPACK FOOTER //
// ./src/features/Backend/components/Backend/components/ProfileManager/index.js